import { createAction } from "@reduxjs/toolkit";

export const setFoodError = createAction<string | null>("food/setError");
